var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.enabled)?_c('vue-recaptcha',{staticClass:"recaptcha",style:((_vm.display ? '' : `display:none;`)),attrs:{"sitekey":this.config.recaptcha.checkboxKey},on:{"render":_vm.rendered,"verify":_vm.verifyAsync}}):_c('div',{staticClass:"recaptcha recaptcha--disabled"},[_vm._v("\n    reCAPTCHA disabled for local debug mode\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }